import Link from 'next/link'
import { cn } from '@/lib/utils/cn'

interface LogoProps {
  className?: string
  collapsed?: boolean
  href?: string
}

export function Logo({ className, collapsed = false, href = '/' }: LogoProps) {
  return (
    <Link
      href={href}
      className={cn(
        'flex items-center gap-2 font-heading font-bold text-encore-primary transition-opacity hover:opacity-80',
        collapsed && 'justify-center',
        className
      )}
    >
      <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-encore-gradient text-white">
        <span className="text-lg font-bold">E</span>
      </div>
      {!collapsed && (
        <span className="text-xl tracking-tight text-encore-primary dark:text-white">Encore-AI</span>
      )}
    </Link>
  )
}
